import flatpickr from 'flatpickr';

const datePicker = (el: HTMLElement): void => {
  // flatpickr.l10ns.default.firstDayOfWeek = 1;
  flatpickr(el, {
    enableTime: false,
    disableMobile: true,
    minDate: Date.now(),
    onChange(selectedDates, dateStr, instance) {
      const formControl = instance.element.parentNode as HTMLElement;
      if (dateStr.length) {
        formControl.classList.add('active');
      } else {
        formControl.classList.add('active');
      }
    }
  });
};

export default datePicker;
